import {
  TRUCK_YARD_GUARD_ROLE_ID,
  TRUCK_YARD_INSPECTOR_ROLE_ID,
  TRUCK_YARD_SUPERVISOR_ROLE_ID,
} from "../../hooks/useTruckYardRole";

/**
 * Qué secciones del patio puede abrir cada rol. UNA sola fuente para el menú
 * (TruckYardLayout) y para el router (TruckYardRoleRoute).
 *
 * Antes la restricción vivía sólo en el menú: un vigilante no veía "Relays" ni
 * "Registros del controlador", pero escribiendo `/truck-yard/relays` en la
 * barra la pantalla abría igual. Ocultar un link no es un permiso.
 *
 * `null` = sin restricción (admin de patio, admin reseller y roles de empresa).
 */
export function allowedTruckYardSections(roleId: string | null | undefined): Set<string> | null {
  // En Dumax inspector y supervisor son roles distintos (los inspectores viejos
  // conservan el id de supervisor): los dos operan, ninguno administra
  // controladores. El servidor los veta igual (hikvisionAccessAuthz.js).
  if (roleId === TRUCK_YARD_SUPERVISOR_ROLE_ID || roleId === TRUCK_YARD_INSPECTOR_ROLE_ID) {
    return new Set(["yards", "vehicles", "access"]);
  }
  if (roleId === TRUCK_YARD_GUARD_ROLE_ID) return new Set(["access"]);
  return null;
}

export function canOpenTruckYardSection(roleId: string | null | undefined, sectionId: string): boolean {
  const allowed = allowedTruckYardSections(roleId);
  return allowed === null || allowed.has(sectionId);
}
